var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading",class:{'ha': _vm.ha},style:({'color': _vm.color})},[_c('a-icon',{attrs:{"type":"loading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }